<div class="card card-nc" *ngIf="hasEntitlement('REGISTER_SHIP') && shipsContact">
  <div class="card-heading">
    <i class="fa fa-ship"></i>
    <span class="cardHeaderHeading"> Pending Ship Registration(s) </span>
  </div>
  <div class="card-body">
    <form *ngIf="newShipForm" name="newShipForm" [formGroup]="newShipForm">
      <table *ngIf="ships?.length" class="table table-striped table-bordered table-hover">
        <thead class="tableheading">
          <tr>
            <th class="text-center">Host Name</th>
            <th class="text-center">UUID</th>
            <th class="text-center">Date Modified</th>
            <th class="text-center">Location</th>
            <th class="text-center"></th>
          </tr>
        </thead>
        <tbody id="pairNewShip">
          <tr *ngFor="let ship of ships | slice: (page - 1) * pageSize : (page - 1) * pageSize + pageSize"
              id="{{ ship.shipUuid }}">
            <td>{{ ship.hostName }}</td>
            <td id="shipUuid">{{ ship.shipUuid }}</td>
            <td id="shipDateModified">{{ ship.dateModified | date: 'MM/dd/yyyy hh:mm:ss' }}</td>
            <td id="shipLocation">
              <input list="LocationSuggestions" id="shipLoc-{{ ship.shipUuid }}" (input)="changeType($event.target.value, ship.shipUuid)">
                <datalist
                  id="LocationSuggestions"
                >
                  <option
                    *ngFor="let location of shipLocations | sort: null"
                    [value]="location"
                  >
                    {{ location }}
                  </option>
                </datalist>
            </td>
            <td>
              <button
                id="button-{{ ship.shipUuid }}"
                type="submit"
                (click)="pairShip(ship.shipUuid)"
                class="form-group btn btn-nc"
                disabled>PAIR<i [ngClass]="{ 'fa fa-spinner fa-spin': processing }"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <ngb-pagination
        [(page)]="page"
        [pageSize]="pageSize"
        [collectionSize]="ships?.length">
      </ngb-pagination>
    </form>
  </div>
</div>
